import { fetchNetlify } from '../netlify'

export const getGiveLivelyDonationEmbedLink = async (
  amount: number,
  ein: string,
  recurring?: boolean
) =>
  await fetchNetlify<string>(
    `/.netlify/functions/give-lively-session?amount=${amount}&ein=${ein}&recurring=${recurring ? 'true' : 'false'}`
  )
